var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":/topic/+_vm.topic_id}},[_c('aside',{staticClass:"topic shadow"},[_c('img',{attrs:{"src":_vm.img}}),_c('p'),_c('h2',{staticClass:"topic-title text-white"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }